import { css } from "@emotion/react";

export const labelStyle = css`
  label {
    font-weight: bold;
  }
`;

export const colGutterStyle = css`
  margin-bottom: 8px;
`;

export const inputLabelContainer = css`
  position: absolute;
  top: 5%;
  left: 5%;
  width: 90%;
  height: 90%;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  background-color: #e4e4e4;
  border-radius: 250px;
  border: 1px dashed #ababab;
`;

export const fullWidth = css`
  width: 100%;
`;

export const buttonLinkBorder = css`
  border-color: #a5c0de;
`;

export const dropzone = css`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;
